"use client";

import Image from "next/image";
import Link from "@/components/Link";
import { AppRoutes } from "@/lib/routeResolver";
import type { ExperienceTour } from "@/lib/navigation";

const FALLBACK_IMGS = [
  "/main/img/tour/tour1.jpg",
  "/main/img/tour/tour2.jpg",
  "/main/img/tour/tour3.jpg",
  "/main/img/tour/tour4.jpg",
  "/main/img/tour/tour6.jpg",
];

export default function ExperienceCard({
  tour,
  index,
}: {
  tour: ExperienceTour;
  index: number;
}) {
  const href = AppRoutes.experienceDestination(tour.destinationSlug);
  const imgSrc = tour.photoURL || FALLBACK_IMGS[index % FALLBACK_IMGS.length];

  return (
    <div className="destination-box3">
      <div className="destination-img">
        <Image
          src={imgSrc}
          alt={tour.name}
          width={797}
          height={530}
          style={{ width: "100%", height: "530px" }}
          unoptimized={!!tour.photoURL}
        />
      </div>
      <div className="box-content">
        <div>
          <Link href={href} className="th-btn style2" title={tour.destinationName}>
            {tour.destinationName}
          </Link>
        </div>
        <h4 className="box-title">
          <Link href={href} title={tour.name}>{tour.name}</Link>
        </h4>
      </div>
    </div>
  );
}
